import { RootState } from '../../types/redux/states/RootState';

export const getRootDomain = ({ environment }: RootState) => environment.rootDomain as string;
